import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Subject } from 'rxjs';
import {
  TrackingDialogNamesEnum,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { AttachmentView } from '../../attachment-view.model';

export const DIALOG_TYPE = 'attachment-view';

@Component({
  selector: 'app-attachment-view-dialog',
  templateUrl: './attachment-view-dialog.component.html',
  styleUrls: ['./attachment-view-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentViewDialogComponent
  implements OnInit, OnChanges, OnDestroy {
  @Input() dialogId: string;
  @Input() attachment: AttachmentView;
  @Input() dialogTitle: string;
  @Input() trackingDialogName: TrackingDialogNamesEnum;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  private _destroyed: Subject<boolean> = new Subject<boolean>();

  dialogType: string;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dialogTitle || changes.attachment) {
      this.dialogTitle =
        this.dialogTitle || (this.attachment && this.attachment.title);
    }
  }

  ngOnInit() {
    this.dialogType = `${DIALOG_TYPE}-${this.dialogId}`;
  }

  ngOnDestroy() {
    this._destroyed.next(true);
    this._destroyed.unsubscribe();
  }
}
